module.exports = __webpack_public_path__ + "img/Delivery fee Icon - white.dfa6e79b.svg";